const Constants = {
  API_URL: process.env.NODE_ENV === 'production' ? 'https://api.realflix.devdavi.com.br' : 'http://192.168.1.9:3333'
};

export default Constants;
